import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Box, Button, MobileStepper, Paper, Typography, useTheme } from "@mui/material";
import _ from "lodash";
import { useState } from "react";
import "./customer-reviews.css";

export default function CustomerReviewsComponent({product}:any): JSX.Element {
  const reviews = _.split(product.backendDescription, '/');

  // customer reviews
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const getCustomerReviews = (): string[] => {
    return _.split(product.backendDescription, '/');
  }

  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = reviews.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  
  return (
    <Box className="reviews" sx={{ maxWidth: 400, flexGrow: 1 }}>
      {reviews.length >= 1 && reviews[0] !== "" ? (
        <div>
        <h4>Customer Reviews</h4>
      <Box className="review-item" sx={{ maxWidth: 400, width: '100%' }}>
        {reviews[activeStep]}
      </Box>
      {reviews.length <= 1 ? '' : (
        <MobileStepper
        variant="text"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
      )}</div>) : ''}
      
      
    </Box>
  )
}